import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditDocumentTypeQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { PencilIcon, WrenchIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from './edit_form'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { EditDesign } from './edit_design'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={id} />, icon: PencilIcon },
    { name: 'Design', component: <EditDesign documentTypeId={id} />, icon: WrenchIcon },
  ]

  const { data, loading } = useQuery<EditDocumentTypeQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="full" onClose={setOpen}>
        <DialogTitle>
          <div>{ loading || !data ? <Loading /> : data.documentTypes.nodes[0].name }</div>
        </DialogTitle>
        <DialogBody>
          <div className="max-h-[75vh] overflow-y-scroll grid grid-cols-2 gap-6">
            <Tabs tabs={tabs} />
            <div className="bg-white/15 rounded-xl">
              { data && data.documentTypes.nodes[0].previewUrl &&
                <embed
                  className="w-full h-full"
                  src={data.documentTypes.nodes[0].previewUrl}
                  type="application/pdf"
                /> }
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  )
}
